import { Heading, HeadingProps } from '@chakra-ui/react';

export const AppHeading = (props: HeadingProps) => {
  return (
    <Heading
      size="lg"
      lineHeight="1.3"
      textAlign="center"
      fontWeight="500"
      {...props}
    />
  );
};
